import ShadowBox from 'common/components/general/ShadowBox';
import Textarea from 'common/components/form/inputs/Textarea';
import Header from '../components/Header';

const Remarks = ({ ...rest }) => {
  return (
    <ShadowBox
      className="pt-1 pb-2 cps-12 cpe-12 w-100p h-100p d-flex flex-column mb-1"
      color="light-1"
      flat
    >
      <Header title="Remarks" />

      <Textarea
        maxLength={255}
        placeholder="Add some text"
        className={'mb-0 cmt-4'}
        name="title"
        rows={8}
        {...rest}
      />
    </ShadowBox>
  );
};

export default Remarks;
